var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c(
      "div",
      { staticClass: "layout_nav" },
      [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
      1
    ),
    _c("div", { staticClass: "layout_center" }, [
      _c(
        "div",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "auto", sm: "auto", md: "auto" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticStyle: { top: "0" },
                                          attrs: {
                                            color: "primary",
                                            icon: "",
                                            dark: "",
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-dots-vertical"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-title",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "on_line",
                                          attrs: { plain: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.readAll()
                                            },
                                          },
                                        },
                                        [_vm._v(" Marcar todos como leídas ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto", sm: "auto", md: "auto" } },
                    [
                      _c("h2", { staticClass: "text-h5" }, [
                        _vm._v("Notificaciones"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-row",
                { attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "4" } },
                    [
                      _vm.isMaster
                        ? _c("v-combobox", {
                            ref: "company",
                            attrs: {
                              items: _vm.itemsDataCompany,
                              "search-input": _vm.searchCompany,
                              "item-value": "_id",
                              "item-text": "name",
                              placeholder: "filtrar empresa",
                              clearable: "",
                            },
                            on: {
                              "update:searchInput": function ($event) {
                                _vm.searchCompany = $event
                              },
                              "update:search-input": function ($event) {
                                _vm.searchCompany = $event
                              },
                            },
                            model: {
                              value: _vm.company,
                              callback: function ($$v) {
                                _vm.company = $$v
                              },
                              expression: "company",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "12", md: "5" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Buscar",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-7",
                      attrs: { cols: "auto", sm: "12", md: "auto" },
                    },
                    [
                      _c(
                        "v-btn-toggle",
                        {
                          model: {
                            value: _vm.toggleFilters,
                            callback: function ($$v) {
                              _vm.toggleFilters = $$v
                            },
                            expression: "toggleFilters",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              attrs: { small: "", outlined: "" },
                            },
                            [
                              _c("v-icon", { attrs: { left: "", dark: "" } }, [
                                _vm._v(" mdi-filter "),
                              ]),
                              _vm._v(" Filtros "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.toggleFilters == 0
            ? _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "v-card-subtitle",
                    [
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "auto" } },
                            [
                              _c("v-combobox", {
                                attrs: {
                                  label: "Evento",
                                  items: _vm.itemsEvents,
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.selectEvent,
                                  callback: function ($$v) {
                                    _vm.selectEvent = $$v
                                  },
                                  expression: "selectEvent",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "auto" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    ref: "date-init",
                                                    attrs: {
                                                      label: "Fecha Inicial",
                                                      "prepend-icon":
                                                        "mdi-calendar",
                                                      clearable: "",
                                                      readonly: "",
                                                      required: "",
                                                    },
                                                    model: {
                                                      value: _vm.dateIni,
                                                      callback: function ($$v) {
                                                        _vm.dateIni = $$v
                                                      },
                                                      expression: "dateIni",
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3164509810
                                  ),
                                  model: {
                                    value: _vm.datePicker1,
                                    callback: function ($$v) {
                                      _vm.datePicker1 = $$v
                                    },
                                    expression: "datePicker1",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    ref: "date-init",
                                    attrs: {
                                      max: new Date()
                                        .toISOString()
                                        .substr(0, 10),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.datePicker1 = false
                                      },
                                    },
                                    model: {
                                      value: _vm.dateIni,
                                      callback: function ($$v) {
                                        _vm.dateIni = $$v
                                      },
                                      expression: "dateIni",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12", md: "auto" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "close-on-content-click": false,
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-text-field",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    ref: "date-dateEnd",
                                                    attrs: {
                                                      label: "Fecha Final",
                                                      "prepend-icon":
                                                        "mdi-calendar",
                                                      clearable: "",
                                                      readonly: "",
                                                      required: "",
                                                    },
                                                    model: {
                                                      value: _vm.dateEnd,
                                                      callback: function ($$v) {
                                                        _vm.dateEnd = $$v
                                                      },
                                                      expression: "dateEnd",
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1138679063
                                  ),
                                  model: {
                                    value: _vm.datePicker2,
                                    callback: function ($$v) {
                                      _vm.datePicker2 = $$v
                                    },
                                    expression: "datePicker2",
                                  },
                                },
                                [
                                  _c("v-date-picker", {
                                    ref: "date-dateEnd",
                                    attrs: {
                                      min: new Date(_vm.dateIni)
                                        .toISOString()
                                        .substr(0, 10),
                                      max: new Date()
                                        .toISOString()
                                        .substr(0, 10),
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.datePicker2 = false
                                      },
                                    },
                                    model: {
                                      value: _vm.dateEnd,
                                      callback: function ($$v) {
                                        _vm.dateEnd = $$v
                                      },
                                      expression: "dateEnd",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.headers,
              items: _vm.itemsData,
              loading: _vm.loadingInfo,
              "footer-props": {
                "items-per-page-options": [10],
              },
              "sort-by": ["updateAt"],
              "sort-desc": [true],
              "items-per-page": 10,
              "server-items-length": _vm.totalNumberOfItems,
              options: _vm.pagination,
              search: _vm.search,
              "item-class": _vm.itemClass,
              "loading-text": "Cargando información ….",
            },
            on: {
              "update:options": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `item.check`,
                  fn: function ({ item }) {
                    return [
                      item.check === true
                        ? _c(
                            "v-icon",
                            { attrs: { "x-small": "", color: "primary" } },
                            [_vm._v("mdi-checkbox-blank-circle")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: `item.register`,
                  fn: function ({ item }) {
                    return [
                      _c("div", { staticClass: "pt-3" }, [
                        _c("p", {
                          domProps: { innerHTML: _vm._s(item.register) },
                        }),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.date`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm._f("formatDateFrom")(item.date)) + " "
                      ),
                    ]
                  },
                },
                {
                  key: `item.actions`,
                  fn: function ({ item }) {
                    return [
                      item.check === true
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "table_menu",
                                                    attrs: {
                                                      color: "primary",
                                                      icon: "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-menu-down"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        { staticClass: "list_action" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { plain: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.editItem(item)
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Marcar leido"),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c("div", [
                            _c("span", { staticClass: "disable-text" }, [
                              _vm._v("Ninguna"),
                            ]),
                          ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }